import { Box, useTheme } from "@mui/material";
import { Toolbar } from "common";
import DateRangeSelector2 from "components/DateRangeSeletor/DateRangeSelector2";
import ProgramCheckboxSelector from "components/ProgramCheckboxSelector/ProgramCheckboxSelector";
import useSettings from "features/settings/useSettings";
import { Moment } from "moment";

interface StreetSalesFilterProps {
  setRange: (range: { start?: Moment; end?: Moment } | undefined) => void;
  range?: { start?: Moment; end?: Moment };
  showPrograms?: boolean;
}

export default function StreetSalesFilter({
  setRange,
  range,
  showPrograms = true,
}: StreetSalesFilterProps) {
  const [settings, setSettings] = useSettings({ key: "streetSales" });

  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
        //position: "sticky",
        //top: 64,
      }}
    >
      <Toolbar sx={{ flex: 1, alignSelf: "stretch", justifyContent: "center" }}>
        <DateRangeSelector2
          numberOfCalendars={1}
          numberOfYears={0}
          value={range}
          onChange={(start, end) => {
            setRange({ start, end });
          }}
          dateButtonMinWidth={240}
        />
      </Toolbar>
      {!!showPrograms && (
        <ProgramCheckboxSelector
          value={settings.programIds || []}
          onChange={evt =>
            setSettings({
              programIds: (evt.target?.value ? evt.target?.value : []) as any,
            })
          }
          showMore={settings.show_all_programs}
          setShowMore={show_all => setSettings({ show_all_programs: show_all })}
        />
      )}
    </Box>
  );
}
